var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCrownTiny = function SvgIconCrownTiny(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11.2,
    viewBox: "0 0 14 11.2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.55,9.8H2.45a.351.351,0,0,0-.35.35v.7a.351.351,0,0,0,.35.35h9.1a.351.351,0,0,0,.35-.35v-.7A.351.351,0,0,0,11.55,9.8Zm1.4-7A1.05,1.05,0,0,0,11.9,3.85a1.029,1.029,0,0,0,.1.433l-1.584.949a.7.7,0,0,1-.967-.254L7.663,1.859a1.05,1.05,0,1,0-1.326,0L4.554,4.979a.7.7,0,0,1-.967.254L2.006,4.283A1.05,1.05,0,1,0,1.05,4.9a1.072,1.072,0,0,0,.168-.017L2.8,9.1h8.4l1.582-4.218a1.072,1.072,0,0,0,.168.017,1.05,1.05,0,1,0,0-2.1Z",
    fill: "#f6c866"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCrownTiny, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-crown-tiny.f173eb3d.svg";
export { ForwardRef as ReactComponent };